import { IconEmailOutline } from '@iwoca/icons';
import { Tooltip } from '@iwoca/orion';

import { useCopyEmail } from '../../../hooks/useCopyEmail';

const CONFIRMATION = 'Email copied to clipboard';

export const CopyEmailButton = ({ email }: { email: string | null }) => {
  const { copied, onCopy } = useCopyEmail(email);

  if (email === null) return null;

  return (
    <>
      <Tooltip
        content={CONFIRMATION}
        placement="bottom-end"
        open={copied}
        // Orion's table is `overflow: hidden`, which clips the bubble at its edge.
        strategy="fixed"
        // The live region below announces instead.
        aria-hidden
        // Lands on the bubble. `orion.css` is bundled after Tailwind, so every
        // property its own rule sets needs `!`. Last child is the arrow.
        className="!max-w-none !whitespace-nowrap !border-secondary-80 !px-l !py-s text-structure-40 !shadow-blue-s [&>div:last-child]:hidden"
      >
        <button
          type="button"
          aria-label="Copy email to clipboard"
          onClick={onCopy}
          className="flex shrink-0 cursor-pointer items-center justify-center rounded-s border-none bg-primary-97 p-s text-primary-40 hover:bg-secondary-90 active:bg-structure-80"
        >
          <IconEmailOutline height="18" width="18" aria-hidden />
        </button>
      </Tooltip>
      {/* Empty rather than unmounted: a live region has to be watched already. */}
      <span role="status" className="sr-only">
        {copied ? CONFIRMATION : ''}
      </span>
    </>
  );
};
